import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import { IQBRPartner } from 'partner360/models/qbr/IQBRPartners'

export const fetchPartnersByFilter = async (filter: string): Promise<{ Data: IQBRPartner[] }> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPQBRPartnersByFilter/call`)

  if (filter.length) {
    const payload = {
      'p.Filter': filter,
    }

    const {
      app: { ownerId },
    } = appGetState()
    const [accessToken] = getTokens(ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    try {
      const response = await Rest.post({ url, payload, headers })

      return {
        Data: response.Data,
      }
    } catch (e) {
      return {
        Data: [],
      }
    }
  }

  return { Data: [] }
}
